"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var storeTagApi = _interopRequireWildcard(require("@/api/storeTagApi.js"));
var toolUtils = _interopRequireWildcard(require("@/utils/toolUtils.js"));
var _store = require("@/api/store");
var _selectProducts = _interopRequireDefault(require("../../business/supplier/coupons/selectProducts.vue"));
var _componentsApi = require("@/api/componentsApi");
var _ButtonUploadExcel = _interopRequireDefault(require("@/components/ButtonUploadExcel"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    SelectProducts: _selectProducts.default,
    ButtonUploadExcel: _ButtonUploadExcel.default
  },
  data: function data() {
    return {
      visibleDrawer: false,
      constants: this.$constants,
      listPram: this.getDefaultListPram(),
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      importLoading: false,
      editDialogConfig: {
        visible: false,
        uploadFile: null
      },
      initDetail: {},
      props: {
        children: 'child',
        label: 'name',
        value: 'id',
        emitPath: false,
        checkStrictly: true
      },
      merCateList: [],
      selectIds: [],
      selectLists: [],
      excelData: [],
      tagType: 1,
      needRefresh: false
    };
  },
  mounted: function mounted() {
    this.getCategorySelect();
    this.listData = {
      list: [],
      total: 0
    };
  },
  methods: {
    getDefaultListPram: function getDefaultListPram() {
      return {
        spuId: '',
        skuId: '',
        productName: '',
        page: 1,
        limit: this.$constants.page.limit[0]
      };
    },
    handleNumberSearchInput: function handleNumberSearchInput(field) {
      var value = String(this.listPram[field] || '').replace(/\D/g, '').slice(0, 50);
      this.listPram[field] = value;
    },
    downModal: function () {
      var _downModal = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _componentsApi.excelTemplateApi)('label_product.xlsx');
            case 1:
              res = _context.v;
              toolUtils.downloadFile(res.fileName, '商品标签批量模版');
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      function downModal() {
        return _downModal.apply(this, arguments);
      }
      return downModal;
    }(),
    initOpen: function initOpen(row) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      this.tagType = type;
      this.initDetail = row || {};
      this.listPram = this.getDefaultListPram();
      this.handlerGetListData(this.listPram);
      this.visibleDrawer = true;
    },
    closeDrawer: function closeDrawer() {
      this.visibleDrawer = false;
      if (this.$refs.selectProductsRef) {
        this.$refs.selectProductsRef.closeEdit();
      }
      this.needRefresh && this.$emit('doRefresh');
    },
    handerSearch: function handerSearch() {
      var needRefresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.needRefresh = needRefresh;
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    handleResetSearch: function handleResetSearch() {
      this.listPram = this.getDefaultListPram();
      this.handlerGetListData(this.listPram);
    },
    getSearchParams: function getSearchParams() {
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var params = _objectSpread({}, pram);
      ['spuId', 'skuId', 'productName'].forEach(function (key) {
        if (params[key] != null) {
          params[key] = String(params[key]).trim();
        }
        if (!params[key]) {
          delete params[key];
        }
      });
      return params;
    },
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      var params = this.getSearchParams(_objectSpread(_objectSpread({}, pram), {}, {
        type: this.tagType,
        labelId: this.initDetail.id
      }));
      storeTagApi.tagProductList(params).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    getBindSpuLabelMap: function () {
      var _getBindSpuLabelMap = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var spuIdList,
          normalizedSpuIds,
          res,
          rawList,
          map,
          targetSet,
          _args2 = arguments;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              spuIdList = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : [];
              normalizedSpuIds = _toConsumableArray(new Set((spuIdList || []).map(function (id) {
                return String(id).trim();
              }).filter(Boolean)));
              if (normalizedSpuIds.length) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, new Map());
            case 1:
              _context2.n = 2;
              return storeTagApi.bindSpuLabelList({
                spuIdList: normalizedSpuIds
              });
            case 2:
              res = _context2.v;
              rawList = Array.isArray(res) ? res : res && (res.list || res.data) ? res.list || res.data : [];
              map = new Map();
              targetSet = new Set(normalizedSpuIds);
              rawList.forEach(function (item) {
                var labelId = item && item.labelId !== undefined && item.labelId !== null ? String(item.labelId) : '';
                var labelName = item && item.labelName ? String(item.labelName) : '';
                var rawSpuList = Array.isArray(item && item.spuList) ? item.spuList : [item && item.spuId];
                rawSpuList.forEach(function (rawSpuId) {
                  var spuId = String(rawSpuId !== undefined && rawSpuId !== null ? rawSpuId : '').trim();
                  if (!spuId || !targetSet.has(spuId)) return;
                  if (!map.has(spuId)) map.set(spuId, []);
                  map.get(spuId).push({
                    labelId: labelId,
                    labelName: labelName
                  });
                });
              });
              return _context2.a(2, map);
          }
        }, _callee2);
      }));
      function getBindSpuLabelMap() {
        return _getBindSpuLabelMap.apply(this, arguments);
      }
      return getBindSpuLabelMap;
    }(),
    getDuplicateLabelGroups: function getDuplicateLabelGroups() {
      var spuIdList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var bindMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Map();
      var normalizedSpuIds = _toConsumableArray(new Set((spuIdList || []).map(function (id) {
        return String(id).trim();
      }).filter(Boolean)));
      var targetSet = new Set(normalizedSpuIds);
      var groupMap = new Map();
      normalizedSpuIds.forEach(function (spuId) {
        var bindings = bindMap.get(spuId) || [];
        bindings.forEach(function (binding) {
          var groupKey = "".concat(binding.labelId || '', "__").concat(binding.labelName || '');
          if (!groupMap.has(groupKey)) {
            groupMap.set(groupKey, {
              labelId: binding.labelId || '',
              labelName: binding.labelName || '',
              spuList: []
            });
          }
          var group = groupMap.get(groupKey);
          if (targetSet.has(spuId) && !group.spuList.includes(spuId)) {
            group.spuList.push(spuId);
          }
        });
      });
      return Array.from(groupMap.values()).filter(function (group) {
        return group.spuList.length > 0;
      });
    },
    buildDuplicateConfirmText: function buildDuplicateConfirmText() {
      var duplicateGroups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (!duplicateGroups.length) return '';
      var parts = duplicateGroups.map(function (group) {
        var labelName = group.labelName || (group.labelId ? "\u6807\u7B7E".concat(group.labelId) : '未知标签');
        return "".concat(labelName, "\u6807\u7B7E\u4E0B\u7684spuId\uFF1A").concat(group.spuList.join('，'));
      });
      return "".concat(parts.join('，'), "\u91CD\u590D\uFF0C\u662F\u5426\u9700\u8981\u8986\u76D6\uFF1F");
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    handleSelectionChange: function handleSelectionChange(selection) {
      this.selectIds = selection.map(function (item) {
        return item.id;
      });
      this.selectLists = selection || [];
    },
    getCategorySelect: function getCategorySelect() {
      var _this2 = this;
      (0, _store.categoryApi)({
        status: -1,
        type: 1
      }).then(function (res) {
        _this2.merCateList = res;
      }).catch(function (res) {
        _this2.$message.error(res.message);
      });
    },
    handlerOpenEdit: function handlerOpenEdit() {
      this.editDialogConfig.visible = true;
      this.excelData = [];
    },
    submitImport: function () {
      var _submitImport = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var normalizedSpuIds, bindMap, duplicateGroups, overwrite, duplicateText, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (this.excelData.length) {
                _context3.n = 1;
                break;
              }
              this.$message.warning('请检查导入文件是否包含spuId！');
              return _context3.a(2);
            case 1:
              this.importLoading = true;
              _context3.p = 2;
              normalizedSpuIds = this.excelData.map(function (spuId) {
                return String(spuId);
              });
              _context3.n = 3;
              return this.getBindSpuLabelMap(normalizedSpuIds);
            case 3:
              bindMap = _context3.v;
              duplicateGroups = this.getDuplicateLabelGroups(normalizedSpuIds, bindMap);
              overwrite = 0;
              if (!duplicateGroups.length) {
                _context3.n = 5;
                break;
              }
              duplicateText = this.buildDuplicateConfirmText(duplicateGroups);
              _context3.n = 4;
              return this.$confirm(duplicateText, '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
              });
            case 4:
              overwrite = 1;
            case 5:
              _context3.n = 6;
              return storeTagApi.bindTagByCode({
                id: this.initDetail.id,
                spuIdList: normalizedSpuIds,
                type: this.tagType,
                overwrite: overwrite
              });
            case 6:
              this.$message.success('操作成功！');
              this.handerSearch(1);
              this.editDialogConfig.visible = false;
              _context3.n = 8;
              break;
            case 7:
              _context3.p = 7;
              _t = _context3.v;
            case 8:
              _context3.p = 8;
              this.importLoading = false;
              return _context3.f(8);
            case 9:
              return _context3.a(2);
          }
        }, _callee3, this, [[2, 7, 8, 9]]);
      }));
      function submitImport() {
        return _submitImport.apply(this, arguments);
      }
      return submitImport;
    }(),
    batchRemove: function batchRemove(removeIds) {
      var _this3 = this;
      this.$confirm('移除后数据不能被恢复，确认移除吗！', '确定移除').then(function () {
        storeTagApi.deleteTagBind({
          productIds: removeIds,
          id: _this3.initDetail.id,
          type: _this3.tagType
        }).then(function () {
          _this3.$message.success('删除数据成功');
          _this3.handerSearch(1);
          _this3.selectIds = [];
          _this3.selectLists = [];
        });
      });
    },
    addProducts: function addProducts() {
      this.$refs.selectProductsRef.openInit(this.initDetail.id);
    },
    getSelectProduct: function () {
      var _getSelectProduct = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(selectedItems) {
        var _this4 = this;
        var productIds, selectedSpuIds, overwrite, bindMap, duplicateGroups, duplicateText, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              productIds = (selectedItems || []).map(function (item) {
                return item && _typeof(item) === 'object' ? item.id : item;
              }).filter(function (id) {
                return id !== undefined && id !== null && id !== '';
              });
              if (productIds.length) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              // 选择商品确认时，也按导入规则做重复校验与确认
              selectedSpuIds = _toConsumableArray(new Set((selectedItems || []).map(function (item) {
                return item && _typeof(item) === 'object' ? item.spuId : '';
              }).filter(function (spuId) {
                return spuId !== undefined && spuId !== null && String(spuId).trim() !== '';
              }).map(function (spuId) {
                return String(spuId).trim();
              })));
              overwrite = 0;
              if (!selectedSpuIds.length) {
                _context4.n = 6;
                break;
              }
              _context4.n = 2;
              return this.getBindSpuLabelMap(selectedSpuIds);
            case 2:
              bindMap = _context4.v;
              duplicateGroups = this.getDuplicateLabelGroups(selectedSpuIds, bindMap);
              if (!duplicateGroups.length) {
                _context4.n = 6;
                break;
              }
              duplicateText = this.buildDuplicateConfirmText(duplicateGroups);
              _context4.p = 3;
              _context4.n = 4;
              return this.$confirm(duplicateText, '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
              });
            case 4:
              overwrite = 1;
              _context4.n = 6;
              break;
            case 5:
              _context4.p = 5;
              _t2 = _context4.v;
              return _context4.a(2);
            case 6:
              storeTagApi.bindTagProduct({
                id: this.initDetail.id,
                productIds: productIds,
                type: this.tagType,
                overwrite: overwrite
              }).then(function () {
                _this4.$message.success('操作成功！');
                if (_this4.$refs.selectProductsRef) {
                  _this4.$refs.selectProductsRef.closeEdit();
                }
                _this4.handerSearch(1);
              });
            case 7:
              return _context4.a(2);
          }
        }, _callee4, this, [[3, 5]]);
      }));
      function getSelectProduct(_x) {
        return _getSelectProduct.apply(this, arguments);
      }
      return getSelectProduct;
    }(),
    onSuccess: function onSuccess(excelData) {
      var results = excelData.results;
      var spuIdList = [];
      results.forEach(function (item, index) {
        if (index === 0) return;
        var raw = item.spuId != null ? item.spuId : item.spuid != null ? item.spuid : item['spuId'] != null ? item['spuId'] : item['spuid'] != null ? item['spuid'] : Object.values(item)[0];
        var spuId = String(raw == null ? '' : raw).trim();
        if (spuId && /^\d+$/.test(spuId)) {
          spuIdList.push(spuId);
        }
      });
      this.excelData = _toConsumableArray(new Set(spuIdList));
      if (!this.excelData.length) {
        this.$message.warning('未识别到有效的spuId，请检查导入模板');
        return;
      }
      this.$message.success('上传成功');
    }
  }
};